import { createEntityAdapter } from '@ngrx/entity';
import { Wellness } from '@app/core/models';
import * as moment from 'moment';

export const getCompletionReportId = ({
  entId,
  date,
}: Pick<Wellness.CompletionReportEntity, 'entId' | 'date'>) =>
  entId + moment(date).format('YYYY-MM-DD');

export const completionReports = createEntityAdapter<
  Wellness.CompletionReportEntity
>({
  selectId: getCompletionReportId,
});
